<template>
    <div>
        <breadCrumb 
            :icon="'fa-comment-lines'"
            :category="$t(`sideNav.navMySalon`)"
            :subCategory="$t(`subMenu.my_salon_message`)"
            :subSubCategory="''">
        </breadCrumb>
        <div v-if="!formToggle" class="text-right mt-3 mr-5">
            <button class="btn buttons-csv buttons-html5 btn-outline-primary" type="button" title="Add New Discount" @click="formToggle = !formToggle">
                <span class="fal fa-plus mr-2"></span>
                <span>{{$t('button_link.compose_message')}}</span>
            </button>
        </div>
        <div v-if="formToggle" class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr">
                    <h2>{{$t('button_link.compose_message')}}</h2>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <messageForm ref="messageForm" :isThirdLevel="false" @returnParent="returnParent"></messageForm>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="px-3 px-sm-5 py-4">
            <div class="panel mb-0">
                <div class="panel-hdr d-block pt-4 p-3">
                    <div class="ml-auto mb-3 text-right">
                        <exportCSV class="link btn buttons-csv buttons-html5 btn-primary mr-2"
                            :data="exportData"
                            :fields="exportFields"
                            :header="exportHeaders"
                            type="csv"
                            :escapeCsv="false"
                            :name="exportFileName">
                            <span>CSV</span>
                        </exportCSV>
                        <!-- <button class="btn buttons-csv buttons-html5 btn-secondary ml-2" type="button" title="Generate PDF">
                            <span class="mr-3">PDF</span>
                            <i class="arrow-down fas fa-angle-down"></i> 
                        </button> --> 
                    </div>
                </div>
                <div class="panel-container">
                    <div class="panel-content">
                        <div v-if="isSpinnerShow" class="d-flex justify-content-center mt-3 mb-3">
                            <b-spinner label="Loading..."></b-spinner>
                        </div>
                        <div class="panel-tag mt-3" v-if="!isSpinnerShow && totalEntries == 0">
                            {{$t('table.no_records')}}
                        </div>
                        <div v-if="!isSpinnerShow && totalEntries != 0" class="dataTables_wrapper dt-bootstrap4">
                            <div class="row justify-content-end mt-2">
                                <div class="col-auto pt-2">
                                    <span>{{$t('table.pagination', {'startPage': startPage, 'endPage': endPage, 'totalEntries': totalEntries,})}}</span>
                                </div>
                                <div class="col-auto">
                                    <b-pagination class="ml-3" v-model="currentPage" :per-page="perPage" :total-rows="totalEntries" @input="handlePagination" aria-controls="tblProductItems"></b-pagination>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-sm-12 overflow-auto">
                                    <b-table small striped hover bordered :fields="fields" :items="messageItems" responsive>
                                        <template #cell(index)="data">
                                            {{ data.index + startPage }}
                                        </template>
                                        <template #cell(createDate)="data">
                                            {{formatDate(data.item.createDate)}}
                                        </template>
                                    </b-table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import moment from 'moment'
import MessageForm from './Message_Form.vue'
import BreadCrumb from './../../Bread_Crumb'
import {handleSessionExpired, setReturnData} from './../../../../assets/js/dashboard/dashboard'
export default {
    name: 'menuMessage',
    components:{
        BreadCrumb, MessageForm
    },
    data(){
        return{
            isSpinnerShow: false,
            formToggle: false,
            messageItems: [],
            page: 0, totalEntries: 0, totalPage: 0, startPage: 1, endPage: 0, perPage: 100, currentPage: 1,
            exportHeaders: [], exportData: [], exportFileName: "", messageExportData: []
        }
    },
    computed:{
        fields(){
            return [
                { key: "index", label: "#", thClass: 'thead-themed align-middle'},
                { key: "createDate", label: this.$i18n.t('table.header.date'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "title", label: this.$i18n.t('table.header.title'), thClass: 'thead-themed align-middle', sortable: true},
                { key: "message", label: this.$i18n.t('subMenu.my_salon_message'), thClass: 'thead-themed align-middle'},
            ]
        },
        exportFields(){
            var ret = {}
            ret["#"] = "index"
            ret[(this.$i18n.t('table.header.date')).toUpperCase()] = "createDate"
            ret[(this.$i18n.t('table.header.title')).toUpperCase()] = "title"
            ret[(this.$i18n.t('subMenu.my_salon_message')).toUpperCase()] = "message"
            return ret
        },
    },
     watch:{
        "$i18n.locale"(val){
            this.setExportData(this.messageExportData)
        }
    },
    methods:{
        formatDate(ts){
            return moment(ts*1000).format(this.$msg.CST.DATE_TIME_24 )
        },
        returnParent(){
            this.formToggle = false
            this.setMessage()
        },
        async setMessage(){
            this.isSpinnerShow = true
            let QUERY_STRING = '?page=' + this.page
            var result = await this.getMessage(QUERY_STRING)

            var retData = setReturnData(result.result, result.count, this.page)
            this.messageItems = retData.result;
            this.totalEntries = result.count;
            this.totalPage = retData.totalPage;

            this.startPage = retData.startPage;
            this.endPage = retData.endPage;
            this.isSpinnerShow = false;

            var expResult = await this.getMessage("")
            this.messageExportData = expResult.result
            this.setExportData(this.messageExportData)
        },
        async getMessage(strFilter){
            let $vm = this
            
            let url = this.$api.MESSAGE + strFilter
            var result = []
            await $vm.$axios({
                method: 'get', 
                url: url,
                baseURL: $vm.$axios.defaults.baseURL, 
                headers: {token: $vm.$session.get('token')},
            })
            .then((response) => {
                if(response.status == 200){
                    result = response.data
                }
            })
            .catch((err) => {
                var errData = err.response.data;
                if(errData.error == $vm.$api.INVALID_TOKEN){
                    handleSessionExpired();  
                }
            })
            return result
        },
        setExportData(data){
            this.exportData = []
            let header = this.$msg.REPORT.HEADER + this.$i18n.t(`subMenu.my_salon_message`)
            this.exportHeaders = [header, this.$i18n.t('table.report_generate') + moment().format(this.$msg.CST.DATE_TIME_24)," "];
            this.exportFileName =  header.split(" ").join("_") +  this.$msg.REPORT.CSV

            for(var i=0; i<data.length; i++){
                this.exportData.push({
                    index: i+1,
                    createDate: this.formatDate(data[i].createDate),
                    title: data[i].title,
                    message: data[i].message,
                })
            }
        },
        handlePagination(pg){
            if(pg != null){
                this.page = pg - 1
                this.setMessage()
            }
        },
    },
    mounted(){
        let $vm = this
        $vm.setMessage()
    }
}
</script>